import { Button as AntButton, Modal } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const ShowRublic4Modal: FC<IProps> = ({
  visible,
  setVisible,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title="Rubric 4 Guide"
      visible={visible}
      width={750}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <table className="table table-bordered">
        <tbody>
          <tr>
            <th className="text-center align-middle font-weight-bold" rowSpan={2}>Rubric 4</th>
            <td className="text-center align-middle">Reading</td>
            <td className="text-center align-middle">Level B, Rise Up</td>
            <td className="text-center align-middle" rowSpan={2}>
              Creative Thinking
            </td>
            <td rowSpan={2}>
              - Content (Creativity)<br />
              - Discourse<br />
              - Language Use<br />
              - Participation
            </td>
          </tr>
          <tr>
            <td className="text-center align-middle">Listening</td>
            <td className="text-center align-middle">Reach Up</td>
          </tr>
        </tbody>
      </table>

      <table className="table table-bordered">
        <tr>
          <td />
          <th className="text-center font-weight-bold">Needs Improvement<br />1</th>
          <th className="text-center font-weight-bold">Fair<br />2</th>
          <th className="text-center font-weight-bold">Good<br />3</th>
          <th className="text-center font-weight-bold">Great<br />4</th>
          <th className="text-center font-weight-bold">Excellent<br />5</th>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Content<br />(Creativity)</th>
          <td>The student has many difficulties expressing any ideas and/or reasoning that have any relevance to the topic.</td>
          <td>The student requires some guidance to express original ideas and/or reasoning that are somewhat relevant to the topic.</td>
          <td>The student expresses at least one partially original idea and/or reasoning that is somewhat relevant to the topic.</td>
          <td>The student expresses original ideas and reasoning that are relevant to the topic.</td>
          <td>The student effectively expresses original ideas and reasoning that are well thought-out and relevant to the topic.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Discourse</th>
          <td>The student has many difficulties explaining simple reasoning for unoriginal ideas. The thought process lacks any organization.</td>
          <td>The student requires some guidance to explain simple reasoning for partially original ideas. The thought process shows some organization with the guidance of the teacher.</td>
          <td>The student explains simple reasoning for their partially original ideas. The thought process shows some organization.</td>
          <td>The student fairly effectively explains the reasoning for their own original ideas. The thought process is fairly well organized.</td>
          <td>The student effectively and coherently explains complex reasoning for their own original ideas. The thought process is well organized and easy to follow.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Language Use</th>
          <td>Grammar needs much/a great deal of improvement. The student’s vocabulary is way below average for the level.</td>
          <td>Grammar needs improvement. The student’s vocabulary is a little below average for the level.</td>
          <td>There are some grammar errors. The student’s vocabulary is somewhat high for the level.</td>
          <td>There are a few grammar errors. The student’s vocabulary is quite high for the level.</td>
          <td>There are almost no grammar errors. The student’s vocabulary is extremely high for the level.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Participation</th>
          <td>The student’s participation is minimal. The student needs to be continuously coerced or prompted to participate.</td>
          <td>The student participates in the discussion with a little prompting from the teacher.</td>
          <td>The student participates in the discussion somewhat actively.</td>
          <td>The student participates in the discussion actively.</td>
          <td>The student participates in the discussion very actively. No coercion or prompting is needed.</td>
        </tr>
      </table>

      <div className="border">
        • Grading Directions: Take a holistic approach when you assign a score. Consider the “average” of the student’s performance. For example, if the student demonstrates “Excellent” content, “Great” presentation, and “Good” delivery, then the student’s average would be “Great,” or a score of 4.
      </div>
    </Modal>
  );
}

export default ShowRublic4Modal;